// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"text-banners_wrapper__cB8KS"};